import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Volvobushireforkhandala() {



const cardData =
{
  keyword: 'Volvo Bus Hire for Khandala',
  heading: 'Sanavi Travels: Volvo Bus Hire for Khandala',
  headingDescription: 'Sanavi Travels provides premium Volvo bus hire for Khandala, offering a smooth, safe, and luxury group travel experience for families, corporate teams, tourists, students, and event groups planning a refreshing hill-station getaway from Pune or nearby cities.',

  top: 'Top Places & Experiences to Enjoy in Khandala with Volvo Bus',

  topPlaces: [
    {
      title: 'Khandala Hill Station – Scenic Western Ghats Retreat',
      description: 'Khandala is one of the most popular hill stations in Maharashtra, known for its misty hills, lush greenery, winding roads, and pleasant climate throughout the year. Traveling in a Volvo bus to Khandala ensures a relaxed and premium journey, especially through ghat sections where comfort and safety matter the most. The smooth air-suspension of a Volvo bus reduces travel fatigue, allowing passengers to enjoy panoramic views of valleys, waterfalls, and forests. Group travel in a Volvo keeps everyone together, avoids convoy driving risks, and makes the journey as enjoyable as the destination itself.'
    },
    {
      title: 'Lion’s Point & Tiger’s Leap',
      description: 'Lion’s Point and Tiger’s Leap are iconic viewpoints offering breathtaking views of deep valleys and mountain ranges. A Volvo bus makes it easy for large groups to reach these spots comfortably, even during peak tourist seasons. The spacious interiors allow passengers to rest between sightseeing stops, which is especially helpful for senior citizens and families with children.'
    },
    {
      title: 'Bhushi Dam & Monsoon Attractions',
      description: 'Bhushi Dam becomes a major attraction during the monsoon, drawing picnic groups, college students, and families. Volvo bus travel ensures safe transport on slippery roads and provides a secure place to relax and change after enjoying water activities. Group coordination becomes simple when everyone travels in one vehicle.'
    },
    {
      title: 'Rajmachi Point & Trekking Zones',
      description: 'Rajmachi Point is popular among trekkers and nature lovers. A Volvo bus is ideal for trekking groups as it offers ample luggage space for backpacks, shoes, and supplies. Early morning departures and late-night returns are more comfortable with reclining seats and climate control.'
    },
    {
      title: 'Corporate Offsites & Team Outings',
      description: 'Many companies choose Khandala for short corporate offsites and team-building activities. Volvo buses support professional travel standards, punctual schedules, and executive-level comfort, making them ideal for corporate groups traveling together.'
    },
    {
      title: 'Family Weekend Getaways',
      description: 'Families enjoy traveling together to Khandala in a Volvo bus, where elders can relax comfortably and children can enjoy the group journey. Shared travel strengthens bonding and removes the stress of managing multiple vehicles.'
    },
    {
      title: 'School & College Excursions',
      description: 'Educational institutions prefer Volvo buses for Khandala trips due to their safety features, disciplined seating arrangement, and ease of supervision. Students remain less fatigued, making the outing more enjoyable and productive.'
    },
    {
      title: 'Photography & Nature Tours',
      description: 'Photographers and nature enthusiasts appreciate the quiet interiors and smooth ride of Volvo buses, which help them reach sunrise and sunset points refreshed and on time.'
    },
    {
      title: 'Multi-Day & Overnight Trips',
      description: 'Khandala tours often extend overnight or include nearby destinations like Lonavala. Volvo buses are well-suited for such multi-day itineraries, providing consistent comfort throughout the journey.'
    },
    {
      title: 'Eco-Friendly Group Travel',
      description: 'Using one Volvo bus instead of multiple cars reduces traffic congestion, fuel consumption, and environmental impact in eco-sensitive hill regions like Khandala.'
    }
  ],

  services: [
    {
      name: 'Volvo Bus Hire for Khandala',
      description: 'Sanavi Travels offers premium Volvo bus hire for Khandala with a focus on luxury, safety, and smooth long-distance travel. Our Volvo buses are equipped with air suspension, reclining push-back seats, powerful air conditioning, large windows for scenic views, and ample luggage space. This service is ideal for families, corporate teams, tourist groups, educational institutions, and event organizers who want a high-end group travel experience to Khandala without compromising comfort or safety.'
    },
    {
      name: 'AC Volvo Bus Khandala',
      description: 'Fully air-conditioned Volvo buses ensure a pleasant and temperature-controlled environment, especially useful during summer trips and crowded weekends.'
    },
    {
      name: 'Luxury Volvo Bus Hire Khandala',
      description: 'Luxury Volvo buses provide premium interiors, silent cabins, and superior ride quality, perfect for VIP guests, corporate leadership teams, and destination events.'
    },
    {
      name: '32 Seater Volvo Bus Khandala',
      description: '32 seater Volvo buses are ideal for medium-sized groups such as offices, colleges, and private tour groups seeking comfort and efficiency.'
    },
    {
      name: '35 Seater Volvo Bus Hire Khandala',
      description: '35 seater Volvo buses accommodate larger groups while maintaining excellent ride comfort and safety standards.'
    },
    {
      name: 'Volvo Bus for Family Khandala',
      description: 'Family-oriented Volvo bus services ensure smooth travel for all age groups, with comfortable seating and professional driving.'
    },
    {
      name: 'Volvo Bus for Corporate Khandala',
      description: 'Corporate Volvo bus services support punctual schedules, professional coordination, and executive comfort for business outings.'
    },
    {
      name: 'Affordable Volvo Bus Rental Khandala',
      description: 'Despite being a premium option, Sanavi Travels offers competitive and transparent pricing for Volvo bus rentals.'
    },
    {
      name: 'Best Volvo Bus Service Khandala',
      description: 'Our reputation comes from reliable operations, well-maintained buses, trained drivers, and high customer satisfaction.'
    },
    {
      name: 'Volvo Bus with Driver Khandala',
      description: 'All Volvo buses come with experienced drivers familiar with Pune–Khandala routes and ghat driving conditions.'
    },
    {
      name: 'Volvo Bus for Wedding Khandala',
      description: 'Destination wedding guest transport and family sightseeing arrangements are managed efficiently with Volvo buses.'
    },
    {
      name: 'Volvo Bus for Picnic Khandala',
      description: 'Picnic and leisure groups enjoy relaxed travel, onboard comfort, and organized group movement.'
    },
    {
      name: 'Volvo Bus for Group Khandala',
      description: 'Group tours are more enjoyable when everyone travels together in a single luxury vehicle.'
    },
    {
      name: 'Outstation Volvo Bus Khandala',
      description: 'Our Volvo buses are fully equipped for outstation journeys, offering reliability and comfort throughout.'
    }
  ],

  tableData: [
    ['AC Volvo Bus', 'Luxury Volvo Bus'],
    ['32 Seater Volvo', '35 Seater Volvo'],
    ['Family Tour', 'Corporate Tour'],
    ['School Trip', 'Weekend Getaway'],
    ['Affordable Plans', 'Premium Travel']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Premium Volvo Fleet',
      WhyChoosedescription: 'Modern Volvo buses with air suspension, push-back seats, and luxury interiors ensure a superior travel experience on ghat roads.'
    },
    {
      WhyChooseheading: 'Experienced Ghat Route Drivers',
      WhyChoosedescription: 'Drivers trained specifically for hill routes and Western Ghats driving conditions.'
    },
    {
      WhyChooseheading: 'High Comfort for Short & Long Trips',
      WhyChoosedescription: 'Reduced fatigue even on winding mountain roads.'
    },
    {
      WhyChooseheading: 'Transparent Pricing',
      WhyChoosedescription: 'Clear pricing policies with no hidden costs.'
    },
    {
      WhyChooseheading: 'Safe & Sanitized Buses',
      WhyChoosedescription: 'Strict safety inspections and sanitation before every trip.'
    },
    {
      WhyChooseheading: 'Flexible Scheduling',
      WhyChoosedescription: 'Custom pickup points and travel schedules available.'
    },
    {
      WhyChooseheading: 'Ideal for Group & Corporate Travel',
      WhyChoosedescription: 'Designed to handle professional and leisure group requirements.'
    },
    {
      WhyChooseheading: '24/7 Customer Support',
      WhyChoosedescription: 'Dedicated assistance from booking to trip completion.'
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide Volvo bus hire for Khandala?',
    answer: 'Yes, Sanavi Travels offers premium Volvo bus hire services for Khandala from Pune and nearby locations.'
  },
  {
    question: 'Are AC Volvo buses available?',
    answer: 'Yes, all Volvo buses are fully air-conditioned.'
  },
  {
    question: 'Is this service suitable for corporate outings?',
    answer: 'Yes, corporate teams frequently book Volvo buses for Khandala offsites.'
  },
  {
    question: 'Are drivers experienced with ghat roads?',
    answer: 'Yes, our drivers are trained for hill station and ghat route driving.'
  },
  {
    question: 'Can families book Volvo buses?',
    answer: 'Yes, family and private group bookings are welcome.'
  },
  {
    question: 'Is advance booking required?',
    answer: 'Advance booking is recommended during weekends and peak seasons.'
  },
  {
    question: 'Are buses sanitized?',
    answer: 'Yes, all buses are sanitized before every trip.'
  },
  {
    question: 'Is pricing transparent?',
    answer: 'Yes, we follow a transparent pricing policy.'
  },
  {
    question: 'Can pickup points be customized?',
    answer: 'Yes, pickup and drop points can be customized.'
  },
  {
    question: 'Is customer support available?',
    answer: 'Yes, 24/7 customer support is available.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Kulkarni',
    feedback: 'We hired a Volvo bus for a family trip to Khandala. The ride was extremely smooth and comfortable, especially on the ghat roads. The driver was professional, and the bus was very clean. It made our weekend getaway truly enjoyable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Joshi',
    feedback: 'Our company booked a Volvo bus from Pune to Khandala for a team outing. Excellent service, premium comfort, and perfect coordination throughout the journey. Highly recommended.',
    rating: 5
  }
];




































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Volvo Bus Hire for Khandala - Sanavi Travels",
  "description": "Sanavi Travels offers Volvo bus hire services for Khandala trips, including AC and Non-AC luxury Volvo buses in 32-seater and 35-seater configurations. Ideal for family trips, corporate travel, group tours, weddings, picnics, and outstation journeys with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Volvo Bus Hire for Khandala | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Volvo buses for Khandala trips with Sanavi Travels. AC & Non-AC luxury 32-seater and 35-seater Volvo buses for family trips, corporate travel, group tours, weddings, picnics, and outstation journeys with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/305.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Volvobushireforkhandala;